/** used to read-only override fields on an object that cannot be modified. For instance, overriding the value of an
 * HTMLInputElement without modifying the DOM */
export const createProxyWithOverrides = (target, overrides) => new Proxy(target, {
    get(original, prop) {
        if (prop in overrides) {
            return overrides[prop];
        }
        return original[prop];
    },
    // added to avoid "invalid invocation" errors, although I don't know why it's necessary
    set(original, prop, value) {
        original[prop] = value;
        return true;
    },
});
//# sourceMappingURL=create-proxy-with-overrides.js.map